<template>
  <div>
    <h3>
      {{ failedFilesCategory }}
    </h3>
    <v-list-item v-for="(uploadObj, index) in failedFiles" :key="index">
      <v-list-item-content class="mt-2">
        <v-list-item-title class="ml-1"
          >{{ uploadObj.testName }}:</v-list-item-title
        >
        <v-list-item-subtitle
          v-for="(errorObj, idx) in uploadObj.errors"
          :key="idx"
          class="red--text mt-2"
        >
          <v-icon>mdi-paperclip</v-icon>
          {{ errorObj.name }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <div v-if="showRetryDialog" class="mt-5 ml-5">
      <div class="mb-4">{{ retryMessage }}</div>
      <v-row>
        <v-col
          cols="12"
          v-for="(uploadObj, index) in failedFiles"
          :key="index"
          class="mb-n6"
        >
          <span
            class="ml-8"
            style="display: inline-block; margin-bottom: 4px;"
            >{{ uploadObj.testName }}</span
          >
          <UploadComponent
            @updateUploadObj="updateUploadObj"
            :testId="uploadObj.testId"
            :testName="uploadObj.testName"
            :updateOnDestroy="false"
            :uploadType="uploadType"
            :noDescription="true"
            required
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import UploadMixin from "../../mixins/UploadMixin.vue";
import UploadComponent from "./UploadComponent.vue";

export default {
  mixins: [UploadMixin],
  components: { UploadComponent },
  props: {
    uploadType: String,
    failedFiles: Array,
    showRetryDialog: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    failedFilesCategory() {
      switch (this.uploadType) {
        case "previousReport":
          return "Previous reports";
        case "consent":
          return "Consent documents";
        default:
          return "";
      }
    },
    retryMessage() {
      switch (this.uploadType) {
        case "previousReport":
          return "Retry previous report uploads";
        case "consent":
          return "Retry consent document uploads";
        default:
          return "";
      }
    },
  },
  watch: {
    prevReportUploadObj: {
      handler(newUploadObj) {
        this.$emit("updateRetryFiles", "retryPrevReportFiles", newUploadObj);
      },
      deep: true,
    },
    consentUploadObj: {
      handler(newUploadObj) {
        this.$emit("updateRetryFiles", "retryConsentFiles", newUploadObj);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
